import { SET_CAMPAIGN_VOICE_LIST } from '../../mutation-types';

const mutations = {
  [SET_CAMPAIGN_VOICE_LIST](state, campaigns) {
    state.campaignVoiceList = campaigns;
  },
};

export default mutations;
